import React, { Component } from "react"
import { Segment, SegmentProps } from 'semantic-ui-react';
import styled from 'styled-components';

const StyledSegment = styled(Segment)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

class PraxStyledSegment extends Component<SegmentProps> {

  render(): React.ReactNode {
    const {children, ...rest} = this.props;
    return (
        <StyledSegment {...rest}>
          {children}
        </StyledSegment>
    )
  }
}

export default PraxStyledSegment;
